module.exports = __webpack_public_path__ + "img/service-01.79e324df.png";